import React from 'react'
import { useFlag, RouteParams } from '@sketch/modules-common'
import { PrototypeLoadingPlaceholder } from '@sketch/components'
import { Redirect, useParams } from 'react-router'
import { LocationDescriptorObject } from 'history'
import useUserProfile from 'modules/user/useUserProfile'
import { useVersioning } from 'modules/versioning'
import { PrototypeViewNext } from './PrototypeViewNext/PrototypeViewNext'

export function PrototypeViewNextFFGate() {
  const { loading } = useUserProfile(false)
  const isWebGLPrototypePlayerOn = useFlag('webgl-prototype-player')
  const { currentArtboardUUID, shareID } = useParams<
    RouteParams<'PROTOTYPE_VIEW_NEXT'>
  >()
  const { getPathname } = useVersioning()

  if (loading) return <PrototypeLoadingPlaceholder />

  if (isWebGLPrototypePlayerOn) {
    return <PrototypeViewNext />
  } else {
    const to: LocationDescriptorObject = {
      pathname: getPathname({
        routeKey: 'PROTOTYPE_VIEW',
        routeParams: {
          shareID,
          artboardUUID: currentArtboardUUID,
        },
      }),
    }
    return <Redirect to={to} push={false} />
  }
}
